import { t } from "@lingui/macro";

import { i18n } from "@base/common/libs/i18n/index.js";
import { showErrorMessage } from "../utils/index.js";
import { Interceptor } from "./interceptor.js";
import { checkStatus, parseJSON } from "./utils.js";

// adding default interceptors
Interceptor.addInterceptor({
  responseError: async (error) => {
    if (error && !error?.statusCode) {
      const offlineMessage = t`Looks like your network connection is unstable. Some actions might fail.`;
      return Promise.reject({
        name: "Offline",
        message: i18n._(offlineMessage)
      });
    }
    return Promise.reject(error);
  }
});
Interceptor.addInterceptor({ response: checkStatus });
Interceptor.addInterceptor({ response: parseJSON });

export class BaseService {
  constructor() {
    this.interceptor = Interceptor;
  }

  sendRequest(url, options) {}

  get(url, options = {}) {
    options.method = "GET";
    return this.sendRequest(url, options);
  }

  post(url, options = {}) {
    options.method = options.method || "POST";
    return this.sendRequest(url, options);
  }

  update(url, options = {}) {
    options.method = "PUT";
    return this.post(url, options);
  }

  patch(url, options = {}) {
    options.method = "PATCH";
    return this.sendRequest(url, options);
  }

  delete(url, options = {}) {
    options.method = "DELETE";
    return this.sendRequest(url, options);
  }

  _sendErrorToast(options, error) {
    if (options.method !== "GET") {
      let showToast = options.hasOwnProperty("toast") ? options.toast : true;
      if (error.name !== "Offline") {
        showToast && showErrorMessage(error);
      }
    }
  }

  download(url) {
    return fetch(url)
      .then(checkStatus)
      .then((response) => response.blob())
      .catch((err) => {
        return Promise.reject(err);
      });
  }
}
